import { filter, mapTo } from 'rxjs/operators';
import { Observable } from 'rxjs';

import ScreenSet from '../ScreenSet';
import Screen from '../Screen';
import { UserData } from '../../../User';
import IdentityType from '../../../services/Dalton/constants/IdentityType';

import loginTemplate from './loginTemplate';

export interface LoginScreenData {
    credential: string;
    identityType: IdentityType;
    principal: string;
}

export interface LoginScreenDependencies {
    user$: Observable<UserData | null>;
}

export default class LoginScreen extends Screen<LoginScreenDependencies> {
    public get data$() {
        return this.dependencies.user$.pipe(
            filter(user => !user),
            mapTo({})
        );
    }

    public get name() {
        return ScreenSet.login;
    }

    public get template() {
        return loginTemplate;
    }
}
